import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../AuthContext";
import { createAnnouncement, getAnnouncements, updateAnnouncement } from "../api";

function AnnouncementPage() {
    const { token } = useContext(AuthContext);
    const [announcements, setAnnouncements] = useState([]);
    const [text, setText] = useState("");
    const [active, setActive] = useState(false);
    const [status, setStatus] = useState(null);

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const load = () => {
        getAnnouncements()
            .then(setAnnouncements)
            .catch(() => setAnnouncements([]));
    };

    const submit = async (e) => {
        e.preventDefault();
        try {
            await createAnnouncement(token, { text, active });
            setStatus("Gespeichert");
            setText("");
            setActive(false);
            load();
        } catch (err) {
            setStatus("Fehler beim Speichern");
        }
    };

    const handleChange = (idx, field, value) => {
        setAnnouncements((prev) => {
            const copy = [...prev];
            copy[idx] = { ...copy[idx], [field]: value };
            return copy;
        });
    };

    const save = async (ann) => {
        try {
            await updateAnnouncement(token, ann.id, { text: ann.text, active: ann.active });
            setStatus("Aktualisiert");
            load();
        } catch (err) {
            setStatus("Fehler beim Speichern");
        }
    };

    return (
        <div className="p-4 max-w-3xl mx-auto">
            <h2 className="text-2xl mb-4">Neue Ankündigung</h2>
            <form onSubmit={submit} className="flex flex-col gap-4 mb-8">
                <textarea
                    className="border p-2"
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    required
                />
                <label className="flex items-center gap-2">
                    <input
                        type="checkbox"
                        checked={active}
                        onChange={(e) => setActive(e.target.checked)}
                    />
                    Aktiv
                </label>
                <button className="bg-blue-600 text-white py-2" type="submit">
                    Speichern
                </button>
                {status && <p>{status}</p>}
            </form>

            <h2 className="text-2xl mb-4">Alle Ankündigungen</h2>
            <table className="w-full border">
                <thead>
                    <tr className="bg-gray-100">
                        <th className="border p-2 text-left">Text</th>
                        <th className="border p-2">Aktiv</th>
                        <th className="border p-2">Aktion</th>
                    </tr>
                </thead>
                <tbody>
                    {announcements.map((a, idx) => (
                        <tr key={a.id} className="border-t">
                            <td className="border p-2">
                                <textarea
                                    className="w-full border p-1"
                                    value={a.text}
                                    onChange={(e) => handleChange(idx, "text", e.target.value)}
                                />
                            </td>
                            <td className="border p-2 text-center">
                                <input
                                    type="checkbox"
                                    checked={a.active}
                                    onChange={(e) => handleChange(idx, "active", e.target.checked)}
                                />
                            </td>
                            <td className="border p-2 text-center">
                                <button
                                    className="bg-blue-600 text-white px-2 py-1"
                                    onClick={() => save(a)}
                                >
                                    Speichern
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default AnnouncementPage;
